import React, { useEffect, useState, useMemo } from "react";
import { Link } from "react-router-dom";
import { getSkills } from "../../services/skillService";

const statusColors = {
  Planned: "bg-gray-100",
  "In Progress": "bg-yellow-100",
  Completed: "bg-green-100",
};

const SkillList = () => {
  const [skills, setSkills] = useState([]);
  const [filter, setFilter] = useState("In Progress");

  useEffect(() => {
    async function fetchSkills() {
      const data = await getSkills();
      setSkills(data);
    }
    fetchSkills();
  }, []);

  const filteredSkills = useMemo(() => {
    if (filter === "all") return skills;
    return skills.filter((skill) => skill.status === filter);
  }, [skills, filter]);

  return (
    <div className="p-0 md:p-2 max-w-6xl mx-auto pb-24">
      {/* HEADER */}
      <div className="flex justify-between items-center mb-4">
        <h1 className="text-2xl font-bold">Skills</h1>
        <Link
          to="/skills/add"
          className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
        >
          + Add Skill
        </Link>
      </div>

      {/* FILTERS */}
      <div className="flex gap-2 mb-6 overflow-x-auto pb-1">
        {["all", "Planned", "In Progress", "Completed"].map((status) => (
          <button
            key={status}
            onClick={() => setFilter(status)}
            className={`px-4 py-1 rounded-full text-sm whitespace-nowrap border transition ${
              filter === status
                ? "bg-blue-600 text-white border-blue-600"
                : "bg-white text-gray-700"
            }`}
          >
            {status === "all" ? "All" : status}
          </button>
        ))}
      </div>

      {/* SKILL CARDS */}
      {filteredSkills.length === 0 ? (
        <p className="text-center text-gray-500 mt-10">
          No skills found.
        </p>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {filteredSkills.map((skill) => (
            <Link
              key={skill.id}
              to={`/skills/${skill.id}`}
              className={`rounded-xl border p-4 shadow-sm hover:shadow-md transition ${
                statusColors[skill.status] || "bg-white"
              }`}
            >
              <h2 className="text-lg font-semibold mb-1">
                {skill.name}
              </h2>

              <p className="text-sm text-gray-600">
                Category: {skill.category}
              </p>

              <p className="text-sm text-gray-600">
                Level: {skill.level}
              </p>

              <div className="mt-3">
                <span className="inline-block text-xs font-semibold px-3 py-1 rounded-full bg-white border">
                  {skill.status}
                </span>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
};

export default SkillList;
